import React from 'react'
import Layout from '../Layout'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

export default function NotFound(props) {
    return (
        <>
            <SEOTAG page="Page Not Found" />
            <Layout props={props}>
                <div
                    className="px-5 py-4 stctPgWrpr text-center"
                    style={{ marginTop: '100px', marginBottom: '100px' }}
                >
                    <h1>We’re sorry, page not found.</h1>
                    <p>
                        You can use our search bar or pick a category below. If you typed in a URL,
                        check it for errors.
                    </p>
                </div>
            </Layout>
        </>
    )
}
